import { render } from "./ModuleSetting.vue?vue&type=template&id=a992208c"
import script from "./ModuleSetting.vue?vue&type=script&lang=js"
export * from "./ModuleSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__